<!-- <div class="body">
    <div class="container pt-3" *ngIf="detalleSolcitud">
        <div class="row">
            <div class="col-12 col-sm-3 text-start">
                <h4>INFORMACIÓN DE LA SOLICITUD</h4>
            </div>
            <div class="col-12 col-sm-3 text-right">
                <span style="font-size: 45px"><i class="fas fa-undo-alt"></i></span>
            </div>
            <div class="col-12 col-sm-6 text-start">
                <h4>¿SEGURO QUE DESEAS DEVOLVER LA OFERTA AL REVISOR?</h4>
            </div>
        </div>

        <div class="row justify-content-md-center mt-4">
            <div class="col-12 col-sm-3">
                <div class="header-inf">
                    No. de Solicitud
                </div>
                <p>{{detalleSolcitud.solicitud.idSolicitud}}</p>
            </div>
            <div class="col-12 col-sm-6">
                <div class="header-inf">
                    Nombre del solicitante
                </div>
                <p>{{detalleSolcitud.InformacionBeneficiario.PrimerNombre}} {{detalleSolcitud.InformacionBeneficiario.PrimerApellido}}</p>
            </div>
            <div class="col-12 col-sm-3">
                <div class="header-inf">
                    Monto solicitado
                </div>
                <p>{{detalleSolcitud.solicitud.monto | currency:'USD' : 'symbol' : '1.0-0'}}</p>
            </div>
        </div>

        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-3">
                <div class="header-inf">
                    Tipo de Identificación
                </div>
                <p>{{detalleSolcitud.InformacionBeneficiario.TipoDeDocumentoDeIdentidad}}</p>
            </div>
            <div class="col-12 col-sm-6">
                <div class="header-inf">
                    Número de identificación
                </div>
                <p>{{detalleSolcitud.InformacionBeneficiario.NumeroDeDocumento}}</p>
            </div>
            <div class="col-12 col-sm-3">
                <div class="header-inf">
                    Plazo solicitado (meses)
                </div>
                <p>{{detalleSolcitud.solicitud.plazo}}</p>
            </div>
        </div>

        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-12">
                <div class="header-inf">
                    Destino del crédito
                </div>
                <p>{{detalleSolcitud.solicitud.destino}}</p>
            </div>
        </div>
        <div class="row justify-content-md-center mt-4">
            <div class="col-12 col-sm-12">
                <div class="header-inf">
                    Número de Solicitud
                </div>
                <p>{{detalleSolcitud.solicitud.idSolicitud}}</p>
            </div>
        </div>
        <div class="row justify-content-md-center mt-4">
            <div class="col-12 col-sm-12" class="text-start">
                <p>Observación</p>
                <textarea name=" " id=" " maxlength="3000" cols="80 " rows="3" name="observacion" #observacion="ngModel" [(ngModel)]="observacionDevolver"></textarea>
            </div>
        </div>
        <div class="row justify-content-md-center mt-4">
            <div class="col-12 col-sm-2">
                <button class="btn btn-primary" (click)="devolver()">Devolver</button>
            </div>
            <div class="col-12 col-sm-2">
                <button class="btn btn-primary" (click)="cancelar()">Volver</button>
            </div>
        </div>
    </div>
    <div class="footer-body"></div>
</div> -->
<app-ver-detalle-propuesta>
    <span class="app">
        <div class="row">
            <div class="col-12 col-sm-3 text-start">
                <h4>INFORMACIÓN DE LA SOLICITUD</h4>
            </div>
            <div class="col-12 col-sm-3 text-right">
                <span style="font-size: 45px"><i class="fas fa-undo-alt"></i></span>
            </div>
            <div class="col-12 col-sm-6 text-start">
                <h4>¿SEGURO QUE DESEAS DEVOLVER LA OFERTA AL REVISOR?</h4>
            </div>
        </div>
    </span>
    <div class="row justify-content-center mt-4">
        <div class="col-12 col-sm-8 text-center">
            <p class="form-label">Observación</p>
            <textarea name=" " id=" " maxlength="3000" cols="80 " rows="3" name="observacion" #observacion="ngModel"
                [(ngModel)]="observacionDevolver" class="form-control"></textarea>
        </div>
    </div>
    <div class="row justify-content-md-center mt-4 g-3">
        <div class="col-12 col-sm-2">
            <button class="btn btn-primary" (click)="devolver()">Devolver</button>
        </div>
        <div class="col-12 col-sm-2">
            <button class="btn btn-primary" (click)="cancelar()">Volver</button>
        </div>
    </div>

</app-ver-detalle-propuesta>

<!-- Modal -->
<div class="modal fade text-center" id="aceptarModal" tabindex="-1" aria-labelledby="aceptarModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body-monto justify-content-md-center">
                <div class="row">
                    <div class="col-12 col-sm-12 me-3 ms-3">
                        <h3>La solicitud ha sido devuelta correctamente</h3>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-md-center">
                <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
            </div>
        </div>
    </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
